export const SNOWPLOW_IS_SETUP = 'snowplow_is_setup'
